<div class="layout-content px-2">
	<form [formGroup]="form" (ngSubmit)="confirm()">
		<div class="grid">

			<div class="col-12">
				<div class="flex align-items-center justify-content-center">
					<p-checkbox formControlName="autoUpdate" class="mr-2" [binary]="true" inputId="fwAutoUpdateEnabled"></p-checkbox>
					<label for="fwAutoUpdateEnabled" class="font-medium cursor-pointer">{{ 'FW_AUTOUPDATE_ENABLED' | translate }}</label>
				</div>
			</div>

			<div class="col-12" formGroupName="schedule">
				<div class="grid">
					<div class="col-12" [ngClass]="customPaddingX()"
						[class]="(this.screenWidth > MAX_MD_WIDTH) ? 'pb-4' : ''">
						<ng-container formArrayName="weekDays">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="manageRespStylewithError(this.sf.weekDays, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="manageRespStylewithError(this.sf.weekDays, 'label')">{{ 'WEEK_DAYS' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="manageRespStylewithError(this.sf.weekDays, 'borderInput')">
									<p-checkbox *ngFor="let day of daysOfWeek" [formControlName]="day.Value" [binary]="true"
										label="{{ day.Name | translate }}" class="ml-4 mt-2"
										[inputId]="'fwDay' + day.Value"
										[class]="showErrorRequiredCheckBox(this.sf.weekDays)">
									</p-checkbox>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.sf.weekDays)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{
								'WEEK_DAYS_REQUIRE' | translate }}</small>
						</ng-container>
					</div>

					<div [ngClass]="col12Responsive() + getSpaceBottomErrorMessage(this.sf.startTime)">
						<div class="flex justify-content-between flex-wrap"
							[ngClass]="newShowErrors(this.sf.startTime, 'borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.sf.startTime, 'label')">{{ 'START_TIME' | translate }}</div>
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.sf.startTime, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="fwStartTime" formControlName="startTime" appendTo="body"
									timeOnly="true" hourFormat="24" [ngClass]="dynamicInputTextWidth()"
									[styleClass]="dynamicInputTextWidth()"
									inputStyleClass="pl-6 sm:pl-5 border-noround-right w-full">
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.sf.startTime)"
							class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
							translate }}</small>
					</div>

					<div [ngClass]="col12Responsive() + getSpaceBottomErrorMessage(this.sf.endTime)">
						<div class="flex justify-content-between flex-wrap"
							[ngClass]="newShowErrors(this.sf.endTime, 'borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.sf.endTime, 'label')">{{ 'END_TIME' | translate }}</div>
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.sf.endTime, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="fwEndTime" formControlName="endTime" appendTo="body"
									timeOnly="true" hourFormat="24" [ngClass]="dynamicInputTextWidth()"
									[styleClass]="dynamicInputTextWidth()"
									inputStyleClass="pl-6 sm:pl-5 border-noround-right w-full">
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.sf.endTime) && !this.sf.endTime?.errors?.['fwAutoupdateMinOneHourGap']"
							class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
							translate }}</small>
						<small *ngIf="this.sf.endTime?.errors?.['fwAutoupdateMinOneHourGap'] && this.sf.endTime?.touched"
							class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{
							'FW_AUTOUPDATE_END_MIN_ONE_HOUR_AFTER_START' | translate }}</small>
					</div>
				</div>
			</div>

		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mx-1 mb-2" [ngClass]="dynamicButtonWidth()" [disabled]="form.pristine">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mx-1 mb-2" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>
